// src/utils/tokenMasuk.js
//
// Link masuk dari WhatsApp: https://rumatkita.com/masuk/<token>. Token itu setara kunci akun,
// jadi tidak boleh ikut tercatat di GA4 (page_location) maupun riwayat browser.
//
// Modul ini WAJIB diimpor paling awal di main.js: kode di bawah langsung jalan saat modul
// dimuat, memindahkan token ke memori lalu mengganti URL menjadi /masuk. Harus sebelum
// router dibuat — vue-router membaca URL saat modulnya dimuat dan akan menulis ulang
// /masuk/<token> — dan sebelum gtag("config") di main.js mengirim page_view pertama.

const POLA = /^\/masuk\/([A-Za-z0-9]{20,100})\/?$/;
const KUNCI = "tokenMasuk";

let token = null;

const cocok = window.location.pathname.match(POLA);
if (cocok) {
  token = cocok[1];
  try {
    // Cadangan bila halaman dimuat ulang sebelum token sempat ditukar.
    sessionStorage.setItem(KUNCI, token);
  } catch (e) {
    // Mode privat browser lama menolak sessionStorage — cukup di memori.
  }
  window.history.replaceState(null, "", "/masuk");
}

export function ambilTokenMasuk() {
  if (token) return token;
  try {
    return sessionStorage.getItem(KUNCI);
  } catch (e) {
    return null;
  }
}

export function lupakanTokenMasuk() {
  token = null;
  try {
    sessionStorage.removeItem(KUNCI);
  } catch (e) {
    // abaikan
  }
}
